export default {
    GET_REGION_LOADING: 'GET_REGION_LOADING',
    GET_REGION_SUCCESS: 'GET_REGION_SUCCESS',
    GET_REGION_FAILED: 'GET_REGION_FAILED',
    GET_REGION_REJECT: 'GET_REGION_REJECT',
  };